import React, { useEffect, useState } from 'react';
import './App.css';
// import logo from './assets/example_logo.svg';
import BasicLayout from './navs/base_layout';
import {
  Provider,
  shallowEqual,
  useDispatch,
  useSelector,
  useStore,
} from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { me } from './stores/auth';
import store from './stores';
import ko_KR from 'antd/lib/locale/ko_KR';
import { ConfigProvider } from 'antd';

const Container = React.memo(() => {
  const dispatch = useDispatch();
  const { principal } = useSelector((s) => s.auth, shallowEqual);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const loadData = async () => {
      await dispatch(me());
    };

    loadData()
      .catch(console.warn)
      .then(() => setLoading(false));
  }, []);

  /*
  useEffect(() => {

    if (!principal) {
    }
  }, [principal]);
  */
  return (
    <BasicLayout
      loading={loading}
      setLoading={setLoading}
      principal={principal}
    />
  );
});
//----------------------------------------------------------------------------------------------------
const App = () => {
  return (
    <Provider store={store}>
      <ConfigProvider locale={ko_KR}>
        <BrowserRouter>
          <Container />
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
